import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import BrandReducer from "./BrandReducer";
import CatalogReducer from "./CatalogReducer";
import DocumentReducer from "./DocumentReducer";
import PrivilegeReducer from "./PrivilegeReducer";
import ProductReducer from "./ProductReducer";
import PromotionReducer from "./PromotionReducer";
import SpareReducer from "./SpareReducer";
import UserReducer from "./UserReducer";

export default combineReducers({
  auth: AuthReducer,
  brand: BrandReducer,
  catalog: CatalogReducer,
  document: DocumentReducer,
  privilege: PrivilegeReducer,
  product: ProductReducer,
  promotion: PromotionReducer,
  spare: SpareReducer,
  user: UserReducer,
});
